import React, { FunctionComponent, ReactNode } from "react";
import { ReactComponent as IconAdd } from "./add-icon.svg";
import { ReactComponent as IconDelete } from "./delete-icon.svg";
import ConfirmModalSmily from "../ConfirmModalSmily";
import "./style.scss";

interface Props {
  children?: ReactNode;
  confirmLabel: string;
  dismissLabel: string;
  display: boolean;
  mode: "error" | "primary";
  onConfirm: () => void;
  onDismiss: () => void;
  title?: string;
  text?: string;
}
const ConfirmChangesModal: FunctionComponent<Props> = ({
  children,
  confirmLabel,
  dismissLabel,
  display,
  mode,
  onConfirm,
  onDismiss,
  title,
  text,
}) => {
  return (
    <ConfirmModalSmily
      className="ConfirmChangesModal"
      confirmLabel={confirmLabel}
      dismissLabel={dismissLabel}
      display={display}
      onConfirm={onConfirm}
      onDismiss={onDismiss}
      position="center"
      showCloseButton={false}
      type="information"
    >
      <div className="ConfirmChangesModal-top">
        {mode === "error" && <IconDelete />}
        {mode === "primary" && <IconAdd />}
      </div>
      <h2 className="ConfirmChangesModal-title">{title || ""}</h2>
      {!!text && <p className="ConfirmChangesModal-text">{text}</p>}
      {children}
    </ConfirmModalSmily>
  );
};

export default ConfirmChangesModal;
